import { Injectable } from '@angular/core';
import {AngularFirestore} from '@angular/fire/firestore';

@Injectable({
  providedIn: 'root'
})
export class EmailTemplatesService {

  constructor(
    private afs: AngularFirestore,
  ) { }

  getChatMessageTemplate() {
    return this.afs.doc('emailTemplates/chatMessage').valueChanges();
  }
  getChatMessageTemplateDE() {
    return this.afs.doc('emailTemplates/chatMessageDE').valueChanges();
  }
  setChatMessage(data) {
    return this.afs.doc('emailTemplates/chatMessage').set(data);
  }
  setChatMessageDE(data) {
    return this.afs.doc('emailTemplates/chatMessageDE').set(data);
  }
  getAccountDeleted() {
    return this.afs.doc('emailTemplates/accountDeleted').valueChanges();
  }
  getAccountDeletedDE() {
    return this.afs.doc('emailTemplates/accountDeletedDE').valueChanges();
  }
  setAccountDeleted(data) {
    return this.afs.doc('emailTemplates/accountDeleted').set(data);
  }
  setAccountDeletedDE(data) {
    return this.afs.doc('emailTemplates/accountDeletedDE').set(data);
  }
  getFirstTrainingTemplate() {
    return this.afs.doc('emailTemplates/firstTraining').valueChanges();
  }
  getFirstTrainingTemplateDE() {
    return this.afs.doc('emailTemplates/firstTrainingDE').valueChanges();
  }
  setFirstTrainingTemplate(data) {
    return this.afs.doc('emailTemplates/firstTraining').set(data);
  }
  setFirstTrainingTemplateDE(data) {
    return this.afs.doc('emailTemplates/firstTrainingDE').set(data);
  }
  getFifthTrainingTemplate() {
    return this.afs.doc('emailTemplates/fifthTraining').valueChanges();
  }
  getFifthTrainingTemplateDE() {
    return this.afs.doc('emailTemplates/fifthTrainingDE').valueChanges();
  }
  setFifthTrainingTemplate(data) {
    return this.afs.doc('emailTemplates/fifthTraining').set(data);
  }
  setFifthTrainingTemplateDE(data) {
    return this.afs.doc('emailTemplates/fifthTrainingDE').set(data);
  }
  getTenthTrainingTemplate() {
    return this.afs.doc('emailTemplates/tenthTraining').valueChanges();
  }
  getTenthTrainingTemplateDE() {
    return this.afs.doc('emailTemplates/tenthTrainingDE').valueChanges();
  }
  setTenthTrainingTemplate(data) {
    return this.afs.doc('emailTemplates/tenthTraining').set(data);
  }
  setTenthTrainingTemplateDE(data) {
    return this.afs.doc('emailTemplates/tenthTrainingDE').set(data);
  }
  getHundredTrainingTemplate() {
    return this.afs.doc('emailTemplates/hundredTrainings').valueChanges();
  }
  getHundredTrainingTemplateDE() {
    return this.afs.doc('emailTemplates/hundredTrainingsDE').valueChanges();
  }
  setHundredTrainingTemplate(data) {
    return this.afs.doc('emailTemplates/hundredTrainings').set(data);
  }
  setHundredTrainingTemplateDE(data) {
    return this.afs.doc('emailTemplates/hundredTrainingsDE').set(data);
  }
}
